
import React from 'react';

export const WHATSAPP_CONFIG = {
    FACEBOOK_APP_ID: '1168572608321711',
    CONFIGURATION_ID: '1200837965543353',
    API_VERSION: 'v24.0'
};

export const SOCIAL_MEDIA = [
    { NAME: 'Facebook', icon: <i className={`fab fa-facebook text-neutral-dark text-[30px]`}></i>, activeIcon: <i className={`fab fa-facebook text-blue-600 text-[30px]`}></i>, color: 'bg-blue-600', textColor: 'text-blue-600', id: 'fb' },
    { NAME: 'Instagram', icon: <i className={`fab fa-instagram text-neutral-dark text-[30px]`}></i>, activeIcon: <i className={`fab fa-instagram text-pink-500 text-[30px]`}></i>, color: 'bg-pink-500', textColor: 'text-pink-500', id: 'ig' },
    { NAME: 'Youtube', icon: <i className={`fab fa-youtube text-neutral-dark text-[30px]`}></i>, activeIcon: <i className={`fab fa-youtube text-red-600 text-[30px]`}></i>, color: 'bg-red-600', textColor: 'text-red-600', id: 'yt' },
    { NAME: 'Google Business', icon: <i className={`fab fa-google text-neutral-dark text-[30px]`}></i>, activeIcon: <i className={`fab fa-google text-red-600 text-[30px]`}></i>, color: 'bg-red-600', textColor: 'text-red-600', id: 'gb' },
    { NAME: 'WhatsApp Business', icon: <i className={`fab fa-whatsapp text-neutral-dark text-[30px]`}></i>, activeIcon: <i className={`fab fa-whatsapp text-green-500 text-[30px]`}></i>, color: 'bg-green-500', textColor: 'text-green-500', id: 'wa' },
]

export const getRandomColor = () => {
    const colors = ['bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-purple-500', 'bg-pink-500'];
    return colors[Math.floor(Math.random() * colors.length)];
};
